import { spaceGQLFields } from '../space/index.js';
import { payloadGQLFields } from './payload.fields.js';
const BASIC_NOTIFICATION_FIELDS = {};
const ALL_NOTIFICATION_FIELDS = {
    actor: 'basic',
    object: 'basic',
    space: 'basic',
    target: 'basic',
};
export function notificationGQLFields(fields) {
    if (fields === 'basic')
        fields = BASIC_NOTIFICATION_FIELDS;
    if (fields === 'all')
        fields = ALL_NOTIFICATION_FIELDS;
    return `
    createdAt
    id
    meta {
      relativeUrl
      url
      body
      textBody
      title
      textTitle
      fullTitle
      textFullTitle
      reason
    }
    read
    verb
    ${fields.actor
        ? `
      actor {
        ${payloadGQLFields(fields.actor)}
      }
    `
        : ``}
    ${fields.object
        ? `
      object {
        ${payloadGQLFields(fields.object)}
      }
    `
        : ``}
    ${fields.space
        ? `
      space {
        ${spaceGQLFields(fields.space)}
      }
    `
        : ``}
    ${fields.target
        ? `
      target {
        ${payloadGQLFields(fields.target)}
      }
    `
        : ``}
  `;
}
//# sourceMappingURL=notification.fields.js.map